import heroImage from "../assets/Images/hero-image.jpg";
import logoImage from "../assets/Images/logo.png";

const heroData = {
	image: heroImage,
	logo: logoImage,
	title: "Construction Funding in the UK",
};

export default heroData;
